import { render, staticRenderFns } from "./AudienceAdditionalDetailsModal.vue?vue&type=template&id=1e9bc408"
import script from "./AudienceAdditionalDetailsModal.vue?vue&type=script&lang=js"
export * from "./AudienceAdditionalDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports